import { render, staticRenderFns } from "./tchDetail.vue?vue&type=template&id=0535fc92&scoped=true"
import script from "./tchDetail.vue?vue&type=script&lang=js"
export * from "./tchDetail.vue?vue&type=script&lang=js"
import style0 from "./tchDetail.vue?vue&type=style&index=0&id=0535fc92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535fc92",
  null
  
)

export default component.exports